import { render, staticRenderFns } from "./ShippingMethodCreate.vue?vue&type=template&id=e3368ab4&"
import script from "./ShippingMethodCreate.vue?vue&type=script&lang=ts&"
export * from "./ShippingMethodCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports